<template>
  <div class="redPacket">
    <el-row :gutter="10">
      <el-col :span="3">
        <div class="grid-content align_right">
          是否开启红包发帖：
        </div>
      </el-col>
      <el-col :span="12">
        <div class="grid-content">
          <template>
            <el-radio v-model="radio" label="1">启用</el-radio>
            <el-radio v-model="radio" label="2">禁用</el-radio>
          </template>
        </div>
      </el-col>
    </el-row>

    <el-row :gutter="10">
      <el-col :span="3">
        <div class="grid-content align_right">
          红包设置：
        </div>
      </el-col>
      <el-col :span="12">
        <template v-for="(item, index) in priceArr">
          <div class="grid-content setLine" :key="index">
            <el-input placeholder="100" v-model="item.days" size="small">
              <template slot="prepend">红包数量</template>
            </el-input>
            <el-input placeholder="120" v-model="item.price" size="small">
              <template slot="prepend">￥</template>
            </el-input>
            <el-button size="small" @click="deletes(index)">删除</el-button>
          </div>
        </template>
      </el-col>
    </el-row>

    <el-row :gutter="10">
      <el-col :span="5" :offset="3">
        <div class="grid-content">
          <el-button size="small" type="primary" @click="setpriceArr" icon="el-icon-plus">增加一种红包设置</el-button>
        </div>
      </el-col>
    </el-row>

    <el-row :gutter="10" class="issue">
      <el-col :span="5" :offset="3">
        <div class="grid-content">
          <el-button size="small" type="primary" @click="issue">提交</el-button>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "redPacket", // 红包设置
  computed: {
    ...mapGetters(["token", "app_id"])
  },
  data() {
    return {
      priceArr: [
        {
          days: "",
          price: ""
        }
      ],
      input1: "",
      fileList: [],
      dialogImageUrl: '',
      dialogVisible: false,
      radio: "1",
      imageUrl: "", //图片地址
      input: "",
      dataArray: "",
      loading: false, //页面loading
      value: ""
    };
  },
  mounted() {},
  methods: {
    // 删除行
    deletes(index) {
      this.priceArr.splice(index, 1);
    },
    // 添加一行数据
    setpriceArr() {
      let data = {
        days: "",
        price: ""
      };
      this.priceArr.push(data);
    },
    issue() {
      this.$router.push({
        path: "/apply/forum/18/lanternSlide"
      })
    }
  }
};
</script>
<style lang="scss" scoped>
.content {
  padding: 0 55px 30px 0;
  height: calc(100vh - 102px);
  min-width: 900px;
  // box-shadow: 0 0 3px #f1f1f1;
}
.redPacket {
  padding: 10px 25px;
  .grid-content {
    min-width: 80px;
    min-height: 32px;
    line-height: 32px;
  }
  .setLine {
    display: flex;
    flex-direction: row;
    margin-bottom: 10px;
  }
  .hint {
    padding: 10px 0;
    color: #909399;
  }
  .align_right {
    text-align: right;
    font-size: 14px;
  }
  .el-row {
    margin-bottom: 20px;
  }
  .issue {
    padding: 10px 0 30px;
  }
}
</style>

<style lang="scss">
.redPacket {
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
}

</style>
